import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isBrowser } from "react-device-detect";
import Form from 'react-bootstrap/Form'
import CustomButton from "../../../../components/CustomButton";
import MediumModal from "../../../../components/modals/MediumModal";
import { closeRejectLabOrderModal } from "../../../../redux/actions/modals";
import { rejectLabOrder } from "../../../../redux/actions/orders";
const RejectLabOrderComponent = () => {
  const dispatch = useDispatch();
  const { reject_lab_order_open, lab_order_reject } = useSelector((state) => state.modals);
  const { lab_order_cancel_reasons_success, reject_lab_order_waiting } = useSelector((state) => state.orders);
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);
  const [rejectDescription, setRejectDescription] = useState('');
  useEffect(() => {
    if(lab_order_cancel_reasons_success.result !== undefined && lab_order_cancel_reasons_success.result === 'SUCCESS'){
      setItems(lab_order_cancel_reasons_success.data.reasons);
    }
  }, [lab_order_cancel_reasons_success]);
  const rejectOrder = () => {
    let data = {
      id : lab_order_reject.id,
      reason : active ?? "OTHER_REASONS",
      more_description : rejectDescription
    };
    dispatch(rejectLabOrder(data));
  };
  return (
    <MediumModal
      header=" دلیل رد سفارش"
      show={reject_lab_order_open}
      closeFunction={closeRejectLabOrderModal}
    >
      <div className={isBrowser ? "" : "reject-order-form-holder-mobile"}>
        {items.map((item, index) => {
          return (
            <button
              className={
                "btn btn-lg action-btn" + (active === item.reasonKey ? " active" : "")
              }
              key={index}
              onClick={() => setActive(active === item.reasonKey ? null : item.reasonKey)}
            >
              {item.reasonValue}
            </button>
          );
        })}
        <Form className="reason-of-reject-lab">
          <Form.Group className="mb-3" controlId="reasons">
            <Form.Label>دلیل رد سفارش خود را بنویسید</Form.Label>
            <Form.Control as="textarea" rows={8} value={rejectDescription} onChange={(description) => setRejectDescription(description.target.value) }  />
          </Form.Group>
        </Form>
        {/* <input type="text" value={rejectDescription} onChange={(description) => setRejectDescription(description.target.value) } className="form-control action-input" placeholder="سایر دلایل خود را بنویسید"/> */}
        <div className="reject-order-action-buttons">
            <CustomButton
              className="btn btn-small btn-success text-white"
              action={rejectOrder}
              type={"success"}
              content={"رد سفارش"}
              textWhite={true}
              loading={reject_lab_order_waiting}
              block={false}
            />
            <button className="btn btn-small btn-outline-black"
            onClick={() => {
                dispatch(closeRejectLabOrderModal());
              }}
            >انصراف</button>
        </div>
      </div>
    </MediumModal>
  );
};

export default RejectLabOrderComponent;
